import React, { useEffect, useRef, useState, useMemo, useContext } from "react";
import { Alert, Box, Button, Checkbox, CircularProgress, Chip, FormControl, FormControlLabel, Grid, LinearProgress, Paper, patch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import CheckIcon from '@mui/icons-material/Check';
import Timer from '../CallBacks/Timer';
import ApiService from "../../functions/apiService";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
import ModalBox from '../../components/Modal/ModalBox';
import { Link } from "react-router-dom";
import moment from 'moment/moment';
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import MyTable from "../../components/Schedule/MyTable";

function LinearProgressWithLabel(props) {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center' }}>
			<Box sx={{ width: '100%', mr: 1 }}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box sx={{ minWidth: 35 }}>
				<Typography variant="body2" color="text.secondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

const CallBackWork = () => {
	const { v3Data } = useContext(AuthContext);
	var params = useParams();
	const batch_id = params?.batch_id;
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [reloadData, setReloadData] = useState(false);
	const [submitingPause, setSubmitingPause] = useState(false);
	const [viewJobsEmp, setViewJobsEmp] = useState([]);
	const [ProgressValue, setProgressValue] = useState(0);
	const [empNowSending, setEmpNowSending] = useState(0);
	const [isPaused, setIsPaused] = useState(true);
	const [timerCount, setTimerCount] = useState(5);
	const [patchId, setPatchId] = useState('');
	const scrollToRef = useRef(null);
	const [showModal, setShowModal] = useState(false);
	const [pauseGrenga, setPauseGrenga] = useState('');
	const [show, setShow] = useState(false);
	const [requestMessage, setRequestMessage] = useState('');
	const [showAccept, setShowAccept] = useState(false)
	const [showReject, setShowReject] = useState(false)
	const [count, setCount] = useState(0);
	const [isWatchParty, setIsWatchParty] = useState(false);
	const [overTimeData , setOverTimeData] = useState([]);
	const [callStatus , setCallStatus] = useState('');
	const [timer , setTimer] = useState(5);

	// const [timer, setTimer] = useState(() => {
	// 	const storedTimer = localStorage.getItem('Timer');
	// 	return storedTimer ? JSON.parse(storedTimer)[0] : 5;
	// });
	// const timerRef = useRef(timer);

	// useEffect(() => {
	// 	timerRef.current = timer;
	// }, [timer]);

	const columnsJobs = () => {
		let columns = [
			{
				field: 'full_name', headerName: 'Name', flex: 1, minWidth: 260,
			},
			{
				field: 'emt', headerName: 'EMT', flex: 1, minWidth: 100,
			},
			{
				field: 'list', headerName: 'List', flex: 1, minWidth: 160,
			},
			{
				field: 'hours', headerName: 'Hours', flex: 1, minWidth: 100,
			},
			{
				field: 'offered', headerName: 'Offered', flex: 1, minWidth: 120,
			},
			{
				field: 'response_text', headerName: 'Status', flex: 1, minWidth: 160,
			},
		];
		{
			columns.push(
				{
					field: 'Actions', headerName: 'Actions', flex: 0, minWidth: 220,
					renderCell: (params) => {
						return (
							params?.row?.response_text	== 'Accepted' ?
								<Button
									variant="contained"
									sx={{
										backgroundColor: 'transparent',
										color: '#01784F',
										marginLeft: '10px',
										padding: '6px 40px',
										boxShadow: 'none',
										borderRadius:'30px',
										border:'1px solid #01784F',
										'&:hover': {
											backgroundColor: 'transparent',
											boxShadow: 'none',
										},
									}}
								>
									{'Accepted'}
								</Button>
							: 
							params?.row?.response_text	== 'Declined' ? 
								<Button
									variant="contained"
									sx={{
										backgroundColor: 'transparent',
										color: '#E62719',
										marginLeft: '10px',
										padding: '6px 40px',
										boxShadow: 'none',
										borderRadius:'30px',
										border:'1px solid #E62719',
										'&:hover': {
											backgroundColor: 'transparent',
											boxShadow: 'none',
										},
									}}
								>
									{'Rejected'}
								</Button>
							: 
							<>
								<Button
									variant="contained"
									onClick={() => {
										acceptReject(params?.row , "accept")
									}}
									sx={{
										backgroundColor: '#01784F',
										color: '#ffffff',
										marginLeft: '10px',
										padding: '8px',
										boxShadow: 'none',
										'&:hover': {
											backgroundColor: '#01784F',
											boxShadow: 'none',
										},
									}}
									disabled={callStatus == true}
								>
									{'Accept'}
								</Button>
								<Button
									variant="contained"
									onClick={() => {
										acceptReject(params?.row , "decline")
									}}
									sx={{
										backgroundColor: '#ff0000',
										color: '#ffffff',
										marginLeft: '10px',
										padding: '8px',
										boxShadow: 'none',
										'&:hover': {
											backgroundColor: '#E62719',
											boxShadow: 'none',
										},
									}}
									disabled={callStatus == true}
								>
									Reject
								</Button>
							</> 
						)
					}
				}
			)
		}
		return columns
	}

	const handleBackClick = () => {
		navigate("/firehouse/callback");
	};

	useEffect(() => {
		if (scrollToRef.current) {
			scrollToRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, [empNowSending]);

	const getDetails = () => {
		// setLoading(true)
		ApiService.post('/callback-employee-admin-list', {
			batch_number: batch_id,
		}).then((data) => {
			setViewJobsEmp(data?.employees)
			setLoading(false);
		}).catch((error) => {
			setLoading(false)
		})
	}

	const getCallDetails = () => {
		ApiService.post('/start-callback', {
			batch_number: batch_id,
			timer: '40'
		}).then((data) => {
			setLoading(false);
		}).catch((error) => {
			setLoading(false)
		})
	}

	// let TimeData = () => {
	// 	setLoading(true);
	// 	ApiService.get(`/batch/progress/${batch_id}`)
	// 		.then((data) => {
	// 			setCount(`${data?.data?.processed} / ${data?.data?.total}`)
	// 			if (empNowSending !== (data?.data?.total - data?.data?.processed)) {
	// 				setTimerCount(5);
	// 			}
	// 			setProgressValue(data?.data?.progress_percentage)
	// 			setLoading(false);
	// 			setEmpNowSending(0);
	// 		}).catch((e) => {
	// 			setLoading(false);
	// 			toast.error(e?.data?.message)
	// 		});
	// };

	const acceptReject = (row , decision) => {
		setLoading(true);
		ApiService.post('/callback-admin-decision', {
			"batch_number" : batch_id,
			"emp_code" : row?.emp_code,
			"decision" : decision
		}).then((data) => {
			toast.success(data?.message || 'Success')
			CallBackStatus()
			if(data?.isFilled){
				navigate('/firehouse/callback')
			}
		}).catch((e) => {
			setLoading(false);
			toast.error(e?.data?.message || 'error')
		});
	};

	let PauseRestart = async () => {
		setSubmitingPause(true);
		try {
			await ApiService.post('/manage-positions', {
				batch_id: jobId,
				action: isPaused ? 'pause' : 'restart',
				timer: timer
			});
			setIsPaused((pre) => !pre);
		} catch (error) {
			toast.error(error?.data?.message);
		} finally {
			setSubmitingPause(false);
		}
	};

	// const handleCellClick = (params) => {
	// 	const selectedRow = overTime.find(row => row.id === params.id);
	// 	if (selectedRow?.Status === 'F') {
	// 		return;
	// 	}
	// 	setRowSelectionModel([params.id]);
	// 	setSelectedShift(selectedRow);
	// };

	// const onRowSelectionModelChange = (newSelection) => {
	// 	const selectedRow = overTime.find(row => row.id === newSelection[0]);
	// 	if (selectedRow?.Status === 'F') {
	// 		setRowSelectionModel([]);
	// 		setSelectedShift(null);
	// 		return;
	// 	}
	// 	setRowSelectionModel(newSelection[0]);
	// 	setSelectedShift(selectedRow);
	// };

	useEffect(() => {
		getCallDetails()
	}, []);

	useEffect(() => {
		if (reloadData) {
			setReloadData(false);
			setLoading(false);
		}
	}, [reloadData]);

	useEffect(() => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAcceptText(res?.data?.data)
			}).catch(({ error }) => {
				console.error('error', error)
			});
	}, [])

	const CallBackStatus = () => {
		ApiService.post('/check-callback-status', {
			"batch_number" : batch_id,
		}).then((data) => {
			setCallStatus(data?.isFilled || '')
			setOverTimeData(data || [])
			if(data?.isFilled){
				navigate('/firehouse/callback')
			}
		}).catch((e) => {
			console.error("e" , e)
		});
	};

	useEffect(() => {
		CallBackStatus();
		getDetails()
		const timer = setInterval(() => {
		  CallBackStatus();
		  getDetails()
		}, 5000);
		return () => clearInterval(timer);
	}, []);

	const DeleteJob = () => {
		ApiService.post('/callback-delete-request', {
			"batch_number" : batch_id,
		}).then((data) => {
			toast.success(data?.message || "Job deleted successfully")
			navigate('/firehouse/callback')
		}).catch((e) => {
			toast.error(e.message || "error")
		});
	};


	return (
		<>
			<Paper className="p-3" style={{ marginTop: "1rem" }} sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF', position: 'relative' }}>
				<Box className="my-1" sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<Typography variant="h6" style={{ marginBottom: "10px" }}>
						Callback
					</Typography>
					<div>
						<ButtonTheme color='primary' style={{ marginLeft: '5px' }} onClick={() => setShowReject(true)}>
							Delete Job
						</ButtonTheme>
						{callStatus == true &&
							<Button style={{ color: '#555555' }} onClick={handleBackClick}>
								<img src="/images/back-button.svg" alt="icon" width='30px' height='30px' />
							</Button>
						}
					</div>
				</Box>

				{loading ? (
					<Box className="w-100 h-100 d-flex justify-content-center align-items-center">
						<CircularProgress />
					</Box>
				) : (
					<>
						<div>
							<Grid container spacing={1}>
								<Grid item xs={12}>
									{/* <div className="hide-header-checkbox-page">
										<CollapseComponent
											rows={overTimeData}
											columns={columnsJobsTob}
											name={`Overtime Shift`}
											checkboxSelection={true}
											isRowSelectable={(params) => params.row.Status !== 'F'}
											onCellClick={handleCellClick}
											open={true}
											rowSelectionModel={rowSelectionModel}
											onRowSelectionModelChange={onRowSelectionModelChange}
										/>
									</div> */}
									<div>
										<p
											className="w-100 text-dark d-flex justify-content-between  p-2 border-0 my-2"
											style={{ backgroundColor: 'rgb(191, 29, 45)' }}
										>
											<span style={{ fontWeight: "400", color: 'white' }}>Callback in Progress</span>
										</p>
										<div style={{border:'1px solid rgb(204, 204, 204)' , padding:'16px'}}>
											<p style={{marginBottom:'6px' , fontSize:'20px', fontWeight:'600'}}>Callback initiated {moment(overTimeData?.overtime_shift?.Create_Time).format("dddd Do MMMM HH:mm:ss")}</p>
											{/* <p style={{marginBottom:'4px'}}>Shift Date : <strong>{moment(overTimeData?.overtime_shift?.Shift_Date).format('MM/DD/YYYY')}</strong></p> */}
											<p style={{marginBottom:'4px'}}>{v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'} Text : <strong>{overTimeData?.overtime_shift?.Detail_Text}</strong> , {v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'} Type : <strong>{overTimeData?.overtime_shift?.Detail_Type}</strong> ,  Assignment : <strong>{overTimeData?.overtime_shift?.Assignment_Code}</strong></p>
											{overTimeData?.employees?.length > 0 && <p style={{marginBottom:'4px'}}>Accepted by : <strong>{overTimeData?.employees?.map((name) => name.name).join(', ')}</strong></p>}
										</div>
									</div>
								</Grid>

								{/* <Grid item xs={3.5}>
									<p
										className="w-100 text-dark d-flex justify-content-between  p-2 border-0 my-2"
										style={{ backgroundColor: 'rgb(191, 29, 45)' }}
									>
										<span style={{ fontWeight: "400", color: 'white' }}>Offered</span>
										<div style={{
											marginBottom: "0px",
											marginLeft: '60%',
											borderRadius: '12px',
											backgroundColor: '#ffffff',
											minWidth: '68px',
											height: '24px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<p style={{ fontSize: '12px', fontWeight: '550', margin: 0, color: '#000000' }}>
												{count}
											</p>
										</div>
									</p>
									<div style={{ border: '1px solid #ccc' }}>
										<TableContainer>
											<Table sx={{ maxWidth: "90vw", overflow: "scroll" }} aria-label="simple table">
												<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
													<TableRow>
														<TableCell width="25%">Jobs</TableCell>
														<TableCell width="30%">Timer</TableCell>
														<TableCell width="45%">Action</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
														<TableCell width="25%">
															{count}
														</TableCell>

														<TableCell width="30%">
															{isPaused ?
																<Timer seconds={timerCount} setSeconds={setTimerCount} />
																:
																<div>
																	<input type="text" className="form-control shadow-none"
																		style={{ width: '60px', fontSize: '12px' }}
																		value={timer}
																		onChange={(e) => {
																			const value = e.target.value;
																			if (/^\d*$/.test(value)) {
																				const newTimer = Number(value);
																				setTimer(newTimer);
																				localStorage.setItem('Timer', JSON.stringify([newTimer]));
																			}
																		}}
																	/>
																</div>
															}
														</TableCell>

														<TableCell width="45%">
															{pauseGrenga === 'pause_last_rank' ?
																<>
																	<img src="/images/onduty.svg" width='20px' height='20px' style={{ marginRight: '5px' }} />
																	Rank Pause
																</>
																: ''
															}
															{!isWatchParty &&
																<ButtonTheme color='primary' style={{ marginLeft: '5px' }} onClick={() => { PauseRestart() }}>
																	{isPaused ? submitingPause ? 'Pausing...' : 'Pause' : submitingPause ? 'Restarting...' : 'Restart'}
																</ButtonTheme>
															}
														</TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
										<LinearProgressWithLabel value={ProgressValue} className='mx-2'></LinearProgressWithLabel>
									</div>
								</Grid> */}
							</Grid>

							<div>
								<Modal show={showModal} onHide={() => setShowModal(false)}>
									<Modal.Header closeButton>
										<Modal.Title>Back</Modal.Title>
									</Modal.Header>
									<Modal.Body>
										<div style={{ padding:'10px' , color:'red' , fontSize:'18px'}}>
											“We’re unable to proceed at the moment as a callback is currently in progress.”
										</div>
									</Modal.Body>
								</Modal>
							</div>

							<div className="mt-3">
								<p
									className="w-100 text-dark d-flex justify-content-between  p-2 border-0 my-2"
									style={{ backgroundColor: 'rgb(191, 29, 45)' }}
								>
									<span style={{ fontWeight: "400", color: 'white' }}>Employees</span>
								</p>
								{viewJobsEmp?.length == 0 ? 
									<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 340 }}>
										<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
										<span className='mt-4' style={{ color: '#555555' }}>
											No Employees Found
										</span>
									</div>
									:
									<div>
										<MyTable
											checkboxSelection={false}
											rows={viewJobsEmp}
											columns={columnsJobs()}
											useTopFilter={false}
											rowCount={viewJobsEmp.length}
											open={true}
											hideFooter={false}
										/>
									</div>
								}
							</div>
						</div>
					</>
				)}
			</Paper>

			{/* Reject Modal */}
			<Modal show={showReject} onHide={() => setShowReject(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Delete Job</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure to Delete this Job ?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShowReject(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => DeleteJob()}>
								Delete
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default CallBackWork